/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConnectionDetails } from './connectionDetails';
import { DoctorLinkStatus } from './doctorLinkStatus';
import { PatientLinkStatus } from './patientLinkStatus';

export interface Reaction { 
    connection_details?: ConnectionDetails;
    patient_link_status?: PatientLinkStatus;
    doctor_link_status?: DoctorLinkStatus;
    blocked?: boolean;
}